<template>
  <v-popover
    interactive
    tag="div"
    content-tag="div"
    :role="'poper'"
    :trigger="'click'"
    :on-show="onTippyShow"
  >
    <template #default="{ state }">
      <div
        ref="variationButton"
        class="filter-variation usn pill-segment"
        :class="{
          pt: variations.length > 1 && !disabled,
          opn: state.isVisible && variations.length > 1 && !disabled,
          'no-chng': variations.length <= 1 || disabled,
        }"
      >
        <div>
          {{ selectedVariationLabel }}
        </div>
      </div>
    </template>
    <template #content="{ state, hide }">
      <VariationList
        v-if="state.isVisible"
        :variations="variations"
        @set-variation="setVariation($event, hide)"
        @variation-dropdown-opened="onTippyShow"
      />
    </template>
  </v-popover>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VariationList from './VariationList.vue';

const emits = defineEmits(['set-variation', 'variation-dropdown-opened']);

const props = defineProps<{
  variations: Array<{ id: string; label: string }>;
  preselectedVariation: string;
  disabled?: boolean;
}>();

const selectedVariationLabel = computed(() => {
  return props.variations.find(
    (v) => v.id === props.preselectedVariation || v.label === props.preselectedVariation
  )?.label;
});

const setVariation = (variation: { id: string; label: string }, hideFn: Function) => {
  if (typeof hideFn === 'function') hideFn();
  emits('set-variation', variation);
};

const onTippyShow = () => {
  if (props.variations.length <= 1 || props.disabled) return false;
  emits('variation-dropdown-opened');
};
</script>

<style lang="scss">
.filter-variation {
  @apply text-xs font-medium text-deEmphasised-text;
  &.opn {
    @apply bg-important-hover;
  }
}
</style>
